<ng-template #pesquisaSatisfacaoComponent>
  <header class="row mx-0 mt-2 mb-0">
    <!-- "header" -->
    <div class="col-11 mt-2 d-flex justify-content-start">
      <bdg-label *ngIf="!isRespondido(); else elseHeader" type="headline" mat-dialog-title
        >Ajude-nos a melhorar o<br />SIGRESIDÊNCIAS</bdg-label
      >
      <ng-template #elseHeader>
        <bdg-label type="headline" mat-dialog-title> Agradecemos sua<br />opinião!</bdg-label>
      </ng-template>
    </div>

    <div class="col-1 modal-close-container d-flex justify-content-end mb-3 pr-2">
      <button
        #closeModal
        class="modal-close-button d-flex justify-content-center"
        mat-icon-button
        aria-label="close dialog"
        mat-dialog-close
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <div class="px-2 pesquisa-body">
    <!-- "body" -->
    <div *ngIf="!isRespondido(); else elseBody">
      <div>
        <div class="px-2">
          <bdg-label type="body-2">Quão satisfeito você está com o sistema?</bdg-label>
        </div>

        <bdg-form [formGroup]="form">
          <app-satisfacao-picker [control]="form?.controls?.grauSatisfacao"></app-satisfacao-picker>

          <div class="p-2 w-100">
            <div class="row p-1">
              <div class="col-6 w-100 d-flex justify-content-start">
                <bdg-label type="body-1"> Muito insatisfeito </bdg-label>
              </div>

              <div class="col-6 w-100 d-flex justify-content-end">
                <bdg-label type="body-1"> Muito satisfeito </bdg-label>
              </div>
            </div>
          </div>

          <div class="row m-0 d-flex">
            <div class="col-12 px-1">
              <bdg-text-area-field
                style="height: 160px"
                [maxLength]="900"
                [label]="textAreaLabel"
                [control]="form.controls.comentario"
                [disable]="shouldDisableSubmit"
              >
              </bdg-text-area-field>
            </div>
          </div>
        </bdg-form>
      </div>
    </div>
    <ng-template #elseBody>
      <div class="d-flex justify-content-center">
        <img
          class="row w-100 agradecemos-ilustracao"
          src="assets/images/agradecemos_sua_opiniao.svg"
          alt="Agradecemos sua opiniao"
        />
      </div>
    </ng-template>
  </div>

  <footer>
    <!-- "footer" -->
    <div class="row m-0 px-2 d-flex">
      <div class="w-100 px-1">
        <bdg-alert type="info" style="font-size: 14px"
          >Caso precise de suporte, entre em contato através do e-mail
          <a style="text-decoration: underline" href="mailto:residencias@saude.gov.br"
            >residencias@saude.gov.br</a
          ></bdg-alert
        >
      </div>
    </div>

    <div *ngIf="!isRespondido(); else elseFooter" class="row m-0 p-2 d-flex flex-row-reverse">
      <div class="p-1">
        <bdg-button label="ENVIAR" matStyle="raised" [disabled]="shouldDisableSubmit" (click)="onSubmit()"></bdg-button>
      </div>
      <div class="p-1">
        <bdg-button (click)="onCancel()" label="NÃO RESPONDER"></bdg-button>
      </div>
    </div>
    <ng-template #elseFooter>
      <div class="row m-0 p-2 d-flex flex-row-reverse">
        <div class="p-1">
          <bdg-button mat-dialog-close label="FECHAR"></bdg-button>
        </div>
      </div>
    </ng-template>
  </footer>
</ng-template>
